import React from 'react';
import {createPortal} from 'react-dom';
import {ModalOverlay, ModalContainer, ModalHeader, ModalBody, ModalFooter} from './styles';

export default function Modal({isOpen, onClose, title, children, footer, narrow = false}) {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleEscKey = React.useCallback(
    (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    document.addEventListener('keydown', handleEscKey);
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [isOpen, handleEscKey]);

  if (!isOpen) {
    return null;
  }

  const modalTree = (
    <ModalOverlay onClick={handleOverlayClick} role="presentation">
      <ModalContainer $narrow={narrow} onClick={(e) => e.stopPropagation()}>
        {title && <ModalHeader>{title}</ModalHeader>}
        <ModalBody>{children}</ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContainer>
    </ModalOverlay>
  );

  if (typeof document === 'undefined' || !document.body) {
    return modalTree;
  }

  return createPortal(modalTree, document.body);
}
